import clsx from 'clsx'
import { useNavigate } from 'react-router-dom'

import { obterDefinicaoDoTipoDeNotificacao } from '@/config'
import { useNotificacoes } from '@/contexts/contexto-notificacoes'
import type { Notificacao } from '@/models'

import classes from './styles.module.scss'

interface CartaoDeNotificacaoProps {
  notificacao: Notificacao
  aoFechar: () => void
}

export function CartaoDeNotificacao({
  notificacao,
  aoFechar,
}: CartaoDeNotificacaoProps): JSX.Element {
  const navegar = useNavigate()
  const { marcarComoLida } = useNotificacoes()

  const definicao = obterDefinicaoDoTipoDeNotificacao(notificacao.tipo)
  const naoVisualizada = !notificacao.visualizado_em

  function aoClicarNoCartao(): void {
    if (naoVisualizada) {
      marcarComoLida(notificacao.id)
    }

    definicao.acao(notificacao.parametros, { navegar })

    aoFechar()
  }

  function aoClicarEmMarcarComoVista(
    evento: React.MouseEvent<HTMLButtonElement>
  ): void {
    evento.stopPropagation()

    marcarComoLida(notificacao.id)
  }

  return (
    <li
      className={clsx(classes.cartao, {
        [classes.naoVisualizada]: naoVisualizada,
      })}
    >
      <button
        type="button"
        className={classes.conteudo}
        onClick={aoClicarNoCartao}
      >
        <span className={classes.icone}>
          <i className={definicao.icone} aria-hidden="true" />
        </span>

        <span className={classes.textos}>
          <span className={classes.titulo}>{definicao.titulo}</span>
          <span className={classes.data}>{notificacao.data}</span>
          <span className={classes.descricao}>{notificacao.descricao}</span>
        </span>
      </button>

      {naoVisualizada && (
        <button
          type="button"
          className={classes.marcarComoVista}
          onClick={aoClicarEmMarcarComoVista}
        >
          Marcar como vista
        </button>
      )}
    </li>
  )
}
